import { Asset, AssetUpdate, UnlinkedAsset } from '../../store/Asset';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';
import { ChartsData } from '../../store/Charts';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getAsset = (id: string) => {
  return apiService.callExternalApi<Asset>({
    url: `${API_SERVER_URL}/assets/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listAssets = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'number', direction: 'desc' }]
  };

  return apiService.callExternalApi<PaginatedResponse<Asset>>({
    url: buildAdvancedQueryURL(mergedFilters, 'assets'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listUnlinkedAssets = (accountId: string, supplierId?: string) => {
  let url = `${API_SERVER_URL}/assets/unlinked/${accountId}`;
  if (supplierId) url += `?supplierId=${supplierId}`;
  return apiService.callExternalApi<UnlinkedAsset[]>({
    url,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const patchAsset = (asset: AssetUpdate) => {
  return apiService.callExternalApi<Asset>({
    url: `${API_SERVER_URL}/assets/${asset.id}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify(asset)
  });
};

export const recalculateFields = (field: string) => {
  return apiService.callExternalApi({
    url: `${API_SERVER_URL}/assets/recalculate-fields/${field}`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const getChartsData = () => {
  return apiService.callExternalApi<ChartsData>({
    url: `${API_SERVER_URL}/assets/charts/all`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
